/**
 * Extrai o nome de arquivo de um header `Content-Disposition: attachment;
 * filename="x.json"` (o `File(...)` do ASP.NET Core manda nesse formato).
 * Cobre também a variante RFC 6266 `filename*=UTF-8''x.json` (encoding
 * explícito), preferindo-a quando presente. `undefined` quando o header não
 * vem ou não tem filename — caller decide o nome de fallback.
 */
export function extrairNomeArquivo(contentDisposition?: string | null): string | undefined {
  if (!contentDisposition) return undefined;

  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      // encoding malformado — cai pro filename simples abaixo, se houver
    }
  }

  const simples = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return simples ? simples[1].trim() : undefined;
}
